import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { CategoryService } from 'src/app/_services/admin/category.service';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.scss']
})
export class AddCategoryComponent implements OnInit {

  AddCategoryForm: FormGroup;
  categorylist: any[] = [];

  constructor(private fb: FormBuilder,
    private router: Router,
    private myTitle: Title,
    private categoryService: CategoryService,
    private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.myTitle.setTitle('Add New Product Categories | ' + environment.commonTitle);
    this.getCategory();
    this.AddCategoryForm = this.fb.group({
      txtCategoryName: new FormControl('', Validators.required),
      ddlParentCategory: new FormControl(null, null)
    });
  }

  getCategory() {
    this.categoryService.getAllCategories().subscribe((result) => {
      if (result.data) {
        this.categorylist = result.data;
      }
    });
  }

  AddCategory() {
    if (this.AddCategoryForm.valid) {
      const objdata = {
        CategoryName: this.AddCategoryForm.value.txtCategoryName,
        ParentCategoryID: this.AddCategoryForm.value.ddlParentCategory
      };
      this.categoryService.addcategory(objdata).subscribe(result => {
        if (result.data) {
          this.getCategory();
          this.openSnackBar('category saved successfully.', 'Category!');
          this.AddCategoryForm.reset();
          this.router.navigate(['/secure/home/product/category']);
        }
      }, error => {
        this.openSnackBar(error, 'Failed to save category');
      });
    }
  }

  reditectCategoryList() {
    this.router.navigate(['/secure/home/product/category']);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }

}
